import { watch, onMounted, onBeforeUnmount } from 'vue';
import useContext from '@/composables/useContext';

export function useRouteScrollReset() {
  const { route } = useContext();

  let popStateTime = 0;
  let pendingScrollY = 0;

  function onPopState(event: PopStateEvent) {
    popStateTime = Date.now();
    pendingScrollY = event.state?.scrollY ?? 0;
  }

  onMounted(() => {
    window.addEventListener('popstate', onPopState);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('popstate', onPopState);
  });

  watch(
    () => route.pathname,
    () => {
      if (typeof window === 'undefined') return;

      const isBack = Date.now() - popStateTime < 500;

      if (isBack) {
        const target = pendingScrollY;
        setTimeout(() => {
          window.scrollTo(0, target);
        }, 150);
        return;
      }

    }
  );
}
